<template lang="pug">
div
  div(:class="[currentFieldIsInvalid ? `${main_class} valid-error` : main_class]")
    q-checkbox(dark, v-model="currentField", :disable="disabled", :label="label", :id="name")

  //span(v-if="currentFieldIsInvalid" class="valid-error-message") {{valid_error_message}}
</template>

<script>
export default {
  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      method: this.parentData.method,
      method_limit: this.parentData.method_limit,
      grid: this.parentData.grid,
      value: this.parentData.data[0].value,
      label: this.parentData.data[0].label,
      name: this.parentData.data[0].name,
      disabled: this.parentData.data[0].disabled,
      depend_from: this.parentData.data[0].depend_from || {},
      watch: this.parentData.data[0].watch || {},
      required: this.parentData.data[0].require,
      valid_error_message: null,
      main_class: "form-checkbox",
    };
  },

  computed: {
    currentField: {
      get() {
        let form_field = this.currentForm[this.name];
        if (form_field) {
          return form_field["field"];
        } else {
          return false;
        }
      },
      set(value) {
        let result = {};
        if (value) {
          result["field"] = value;
          result["invalid"] = this.invalid(value);
        } else {
          result["field"] = false;
          result["invalid"] = this.invalid();
        }
        this.$store.commit("updateFormField", { grid_name: this.grid, field: this.name, value: result });
        if (!result["invalid"]) {
          this.$store.commit("resetFormFieldValue", {
            grid_name: this.grid,
            field: "invalid_fields",
            value: this.name,
          });
        }
      },
    },

    fieldDependency() {
      return this.checkDependency();
    },
  },

  watch: {
    fieldDependency(newVal, oldVal) {},
  },

  created() {
    this.watchSimpleFieldParents();
  },

  beforeMount() {
    this.$store.commit("createFormField", { grid_name: this.grid, field: this.name });
    this.setField(this.value);
  },

  methods: {
    setField(val) {
      this.currentField = val;
    },

    invalid(val = undefined) {
      if (this.required) {
        if (val) {
          this.valid_error_message = null;
          return false;
        } else {
          this.valid_error_message = this.notifies.not_empty;
          return true;
        }
      } else {
        this.valid_error_message = null;
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../../assets/styles/forms/fields/checkbox";
</style>
